import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, Container, Typography } from "@mui/material";
import { redeemShareToken } from "../../axios/axiosFunctions";
import { ReportAccessContext } from "../../contexts/reportAccess";

const RedeemShareLink = () => {
    const { token } = useParams();
    const { setShare } = useContext(ReportAccessContext);
    const navigate = useNavigate();
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const res = await redeemShareToken(token);
            if (cancelled) return;
            if (res.error || !res.token) {
                setError(res.msg || "This link is no longer valid.");
                return;
            }
            const { share } = res;
            setShare({
                token: res.token,
                shareId: share._id,
                groupId: share.group,
                assessmentId: share.assessment,
                recipientEmail: share.recipientEmail,
                recipientName: share.recipientName,
                viewerUserId: res.viewerUserId,
            });
            // Route to the report of the shared assessment (TIM or an as-is clone
            // such as Executive Team Assessment). Fall back to TIM for old shares
            // whose response predates the assessmentSlug field.
            const reportSlug = share.assessmentSlug || "tim_self_assessment";
            navigate(`/${reportSlug}/${share.group}/report`, { replace: true });
        })();
        return () => {
            cancelled = true;
        };
    }, [token, setShare, navigate]);

    if (error) {
        return (
            <Container maxWidth="sm" sx={{ mt: 8 }}>
                <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                <Typography variant="body2" sx={{ mb: 3 }}>
                    The link may have expired or been revoked. You can enter your email and the
                    6-digit access code from the email instead.
                </Typography>
                <Button variant="contained" onClick={() => navigate("/access-report", { replace: true })}>
                    Enter access code
                </Button>
            </Container>
        );
    }

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <CircularProgress />
        </Box>
    );
};

export default RedeemShareLink;
